/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Comment_SubmitInputs */

const en_comment_submit = /** @type {(inputs: Comment_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send comment`)
};

const ja_comment_submit = /** @type {(inputs: Comment_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメントを送信`)
};

const fr_comment_submit = /** @type {(inputs: Comment_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envoyer le commentaire`)
};

const de_comment_submit = /** @type {(inputs: Comment_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kommentar senden`)
};

/**
* | output |
* | --- |
* | "Send comment" |
*
* @param {Comment_SubmitInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const comment_submit = /** @type {((inputs?: Comment_SubmitInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Comment_SubmitInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_comment_submit(inputs)
	if (locale === "ja") return ja_comment_submit(inputs)
	if (locale === "fr") return fr_comment_submit(inputs)
	return de_comment_submit(inputs)
});